import React from 'react'
import { Tabs as MuiTabs, Tab as MuiTab, Typography } from '@mui/material'
import { useTheme, Box } from '@mui/material'

export type TabId = number

export type TabItem<T extends TabId> = {
  id: T
  label: string | JSX.Element
}

export type TabsProps<T extends TabId> = {
  tabs: readonly TabItem<T>[]
  selectedTabId: number
  setSelectedTab: (id: T) => void
}

export type Ilabel = {
  label: string | JSX.Element
}

const TabLabel = ({ label }: Ilabel) => {
  const { palette } = useTheme()
  const styles = {
    tabLabel: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '10px',
    },
    badge: {
      border: `1px solid ${palette.common.white}`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '3px 5px',
      borderRadius: '6px',
      lineHeight: '1px',
      fontSize: 10,
    },
  }

  return (
    <Box sx={styles.tabLabel}>
      <Typography component="span" variant="subtitle1">
        {label}
      </Typography>
    </Box>
  )
}

const Tabs = <T extends TabId>({ tabs, selectedTabId, setSelectedTab }: TabsProps<T>) => {
  const { palette } = useTheme()
  const styles = {
    tabs: {
      '& .MuiTabs-flexContainer': {
        width: '100%',
        border: 'none',
      },
      '& .MuiTab-root': {
        color: palette.common.black,
        padding: '6px 0 6px',
      },

      '& .MuiTabs-indicator': {
        backgroundColor: palette.common.black,
      },
    },
  }

  const handleTabChange = (_event: React.ChangeEvent<object>, newValue: T) => {
    setSelectedTab(newValue)
  }

  return (
    <MuiTabs variant="fullWidth" value={selectedTabId} onChange={handleTabChange} sx={styles.tabs}>
      {tabs.map(({ id, label }) => (
        <MuiTab key={id} value={id} label={<TabLabel {...{ label }} />} />
      ))}
    </MuiTabs>
  )
}

export default Tabs
